import React from "react";
import { ensure } from "sprint-common-web";

import { OrderProgressData } from "../../utils/calculateOrderProgress";
import { OrderCompletionProgressInfo } from "./OrderCompletionProgressInfo";

export const renderOrderProgress = <T extends { id: string; progress: OrderProgressData }>(item?: T): JSX.Element => {
    ensure(item);

    return (
        <OrderCompletionProgressInfo
            progress={item.progress}
            key={`${item.id}-cloud-progress`}
            testId="order-completion-progress"
        />
    );
};
